export const brandName = 'StruxHub'
export const brandShortName = 'STX'
